import React from 'react';
import { Link } from 'react-router-dom';
import "../styles/Developers.css";

export const Sarah = () => {
    return(
        <div className="developer-profile-container">
            <h1 className="developer-header">About Sarah</h1>
            <img 
                src="https://engineering.buffalo.edu/content/shared/engineering/computer-science-engineering/profiles/faculty/teaching/hunt-alan/jcr:content/profileinfo.img.280.280.z.q65.jpg/1575582416594.jpg" 
                alt="Sarah's Portrait" 
                className="developer-image" 
            />
            <p className="developer-bio">
                Sarah is a student at the University at Buffalo studying computer science.
                She enjoys coding in assembly as well as working with others. Sarah is very outgoing and 
                personable which makes her a great asset to our sales and development team. 
                Our vision for this project was to be able to minimize time spent on deciding on a 
                cuisine to eat for the UB student body. We expect to save on time and frustration for
                students in order to focus on studies and making connections with other people. 
                Our dream is to have an interactive platform for students to express their thoughts 
                on the campus offered food.
            </p>
            <Link to="/about" className="back-button">Back to Developers</Link>
        </div>
    );
};
